import { render, staticRenderFns } from "./LatestInvestorMerchantContract.vue?vue&type=template&id=58c53ace&scoped=true&"
import script from "./LatestInvestorMerchantContract.vue?vue&type=script&lang=js&"
export * from "./LatestInvestorMerchantContract.vue?vue&type=script&lang=js&"
import style0 from "./LatestInvestorMerchantContract.vue?vue&type=style&index=0&id=58c53ace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c53ace",
  null
  
)

export default component.exports